import React from "react";
import Grid from "@material-ui/core/Grid";
import HeaderAll from "../../../HeaderAll";

function HeaderMulti(props) {
  const { info ,infoData} = props;

  const styf = { fontWeight: "1200" };
  const styTitle = { fontWeight: "1500" };

  return (
    <Grid item container
      justifyContent="center"
      style={{
        paddingTop: "1rem", fontWeight: "bold", fontFamily: "Amiri-Regular",
      }}>
      <HeaderAll Report={true} found={info} />

      <Grid item container style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}>
        <Grid item xs={12} style={{
          fontFamily: "Amiri-Regular", border: "solid 2px", paddingTop: "0.5rem", paddingBottom: "0.5rem",
          borderRadius: "5px", textAlign: "center",
        }}
        >
          <div style={styf}>
            <div style={styTitle}>{infoData?.title}</div>
          </div>
        </Grid>
      </Grid>
      <Grid item container style={{
        fontFamily: "Amiri-Regular", padding: "0.3rem", border: "solid 2px",
        borderRadius: "5px", direction: "rtl",
      }}
      >
        <Grid item xs={12} container>
          <Grid item xs={4} style={{ textAlign: "right" }}>
            {"رقم السند"} /{" "} {infoData?.dataH?.id}
          </Grid>
          <Grid item xs={4} style={{ textAlign: "right" }}>
            {infoData?.type==="1"? "الصندوق":"البنك"} /{" "} {infoData?.stockName}
          </Grid>
          <Grid item xs={4} style={{ textAlign: "right" }}>
            {"التاريخ"} /{" "} {infoData?.dataH?.date}
          </Grid>

        </Grid>
        <Grid item xs={12} container style={{ textAlign: "right", paddingTop: "0.3rem" }}>
          <Grid item xs={4} style={{ textAlign: "right" }}>
            {"البيان"} /{" "} {infoData?.dataH?.notes}
          </Grid>
          <Grid item xs={4}>
            {"المستخدم"}  {"   /"}  {infoData?.userName?? "------"}
          </Grid>
          <Grid item xs={4}>
            {"تاريخ الطباعة"} {"    /"} {infoData?.nDate}
          </Grid>

        </Grid>
      </Grid>
    </Grid>
  );
}
export default HeaderMulti;